<template>
    <div>
        <b-container>
            <b-row>
                <div id="chat-messages" class="chat-container">
                    <div v-for="(message, index) in messages" :key="index">
                        <div class="message">
                            {{message.username}} : {{message.content}}
                        </div>
                    </div>
                </div>
            </b-row>
        <b-row class="input" style="margin-top:10px;">
            <b-input v-model="messageUser" v-on:keyup.enter="sendMessage"></b-input>
            <b-button @click="sendMessage">Send Message</b-button>
        </b-row>
        </b-container>


    <b-modal ref="selectUsername" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          Select an username to send message
        </h4>
      </div>
      <p style="line-height: normal">
        Please select an username to send message in the chatRoom
      </p>
      <b-input v-model="usernameTmp"></b-input>
      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" 
          @click="setUsername();hideModal('selectUsername');"
        >
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          Set username
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" 
          @click="hideModal('selectUsername');"
        >
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>

        <b-modal ref="usernameAlreadyTaken" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'cut']" />
          Creating cut-versions: <span style="color: red">error</span>
        </h4>
      </div>
      <p style="line-height: normal">
        The username {{usernameTmp}} is already taken, please select another one.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('usernameAlreadyTaken')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>


    </div>
</template>

<script>
  import {WS_CHAT_LIVE, WS_CHAT_LIVE_PATH, BASE_URL} from "@/services/base-url.js"
  import { io } from "socket.io-client";
  var ws_chat_url = WS_CHAT_LIVE;
  var ws_chat_path = WS_CHAT_LIVE_PATH;
  var base_url = BASE_URL;

export default {
    name: "videoChat",
      props: [
      'roomId'
    ],
    data: function () {
        return {
            //Les messages se présenteront comme des objets : 
            //{username:"auteur", content:"message"}
            messages:[],
            liveID:"",
            username:"",
            messageUser:"",
            socketChat:null,
            usernameTmp:"",
        }
    },
    methods:{
        sendMessage(){
            if(this.username)
            {
                if(this.messageUser && this.socketChat)
                {
                    this.socketChat.emit("sendMessage", this.messageUser, this.username ,this.roomId)
                }
                this.messageUser = "";
            }else{
                this.showModal("selectUsername");
            }

        },
        formatMessage(user, content)
        {
            let message = {
                username:user,
                content:content
            }
            
            var messages = document.getElementById("chat-messages")
            let toScroll = Math.round(messages.scrollTop) + messages.clientHeight-1 === messages.scrollHeight;

            this.messages.push(message);
            this.messages.splice();

            if(toScroll)
                window.setTimeout(function(){messages.scrollTop = messages.scrollHeight;},100)
        }, 
        connectToChat()
        {
            if(!this.socketChat)
            {
                this.socketChat = io(ws_chat_url, { path: ws_chat_path });

                this.socketChat.on("connect", () => {
                    this.socketChat.emit("room", this.roomId, this.username)
                })
                
                this.socketChat.on('joined', (roomId) => {
                    console.log("Succesfully joined chat : " + roomId)
                })

                this.socketChat.on("newMessage", (message, username, roomId)=>{
                    if(this.roomId === roomId)
                        this.formatMessage(username, message);
                })

                this.socketChat.on("usernameAlreadyTaken", ()=>{
                    this.showModal("usernameAlreadyTaken")
                })

                this.socketChat.on("usernameOK", ()=>{
                    console.log("here")
                    this.username = this.usernameTmp
                    this.sendMessage();
                })
            }
        },
        setUsername()
        {
            console.log("On set le nom")
            this.socketChat.emit("setUsername",this.roomId, this.usernameTmp)
        },
        showModal(ref) {
        this.$refs[ref].show();
        },
        hideModal(ref) {
        this.$refs[ref].hide();
        },
    },
    mounted()
    {
        if(this.$route.params["liveId"])
            this.roomId = this.$route.params["liveId"]
        this.connectToChat();
    },

}

</script>

<style scoped lang="scss">

 .chat-container {
     height:90vh;
     width:100%;
     background-color:greenyellow;
     overflow-y:scroll;
}

.message {
    overflow-wrap: break-word;
}

</style>